// The session-boot loading indicator. Instead of a generic ring it shows the
// landing site's signature: the version-control spine "initializing" — a commit
// pulse flows down the branch and the two commit nodes breathe. This mirrors the
// branchcad.com intro reveal so the very first thing a visitor sees in the app is
// continuous with the marketing site. Motion lives in index.css and is
// reduced-motion-safe (it resolves to a clean static mark). role="status" +
// aria-label keep it announced; the label default is unchanged so every existing
// caller (<FullScreenSpinner />) is untouched.
export default function FullScreenSpinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div
      className="flex min-h-full items-center justify-center p-8"
      role="status"
      aria-label={label}
    >
      <div className="flex flex-col items-center gap-4">
        <svg width="56" height="92" viewBox="0 0 56 92" fill="none" role="presentation">
          {/* the quiet guide spine (the full branch) */}
          <path
            d="M28 12 V 80"
            stroke="var(--cad-panel-border, rgba(0,0,0,0.12))"
            strokeWidth="2"
            strokeLinecap="round"
          />
          {/* the accent commit pulse flowing down the branch (git history writing) */}
          <path
            className="brand-spinner-flow"
            d="M28 12 V 80"
            stroke="var(--cad-accent, #6e56f8)"
            strokeWidth="2"
            strokeLinecap="round"
          />
          {/* HEAD commit (filled) */}
          <circle className="brand-spinner-node" cx="28" cy="16" r="6" fill="var(--cad-accent, #6e56f8)" />
          {/* next commit (hollow) */}
          <circle
            className="brand-spinner-node brand-spinner-node-2"
            cx="28"
            cy="76"
            r="5"
            fill="var(--cad-bg, #f6f8fa)"
            stroke="var(--cad-accent, #6e56f8)"
            strokeWidth="2"
          />
        </svg>
        <span className="brand-spinner-label brand-eyebrow text-muted-foreground">{label}</span>
      </div>
    </div>
  );
}
